// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { PriorAuthorizationAddress } from './priorAuthorizationAddress.js';
import type { PriorAuthorizationPatientGender } from './priorAuthorizationPatientGender.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class MedicalV1PriorAuthorizationInterfacesPriorAuthorizationPatient {
    'firstName': string;
    'lastName': string;
    'middleName'?: string;
    'dateOfBirth': string;
    'gender': PriorAuthorizationPatientGender;
    'address': PriorAuthorizationAddress | null;
    'patientId'?: string;
    'phone'?: string;
    'contactName'?: string;
    'contactNumber'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof MedicalV1PriorAuthorizationInterfacesPriorAuthorizationPatient>> = [
        {
            "name":     "firstName",
            "baseName": "firstName",
            "type":     "string"
        },
        {
            "name":     "lastName",
            "baseName": "lastName",
            "type":     "string"
        },
        {
            "name":     "middleName",
            "baseName": "middleName",
            "type":     "string"
        },
        {
            "name":     "dateOfBirth",
            "baseName": "dateOfBirth",
            "type":     "string"
        },
        {
            "name":     "gender",
            "baseName": "gender",
            "type":     "PriorAuthorizationPatientGender"
        },
        {
            "name":     "address",
            "baseName": "address",
            "type":     "PriorAuthorizationAddress"
        },
        {
            "name":     "patientId",
            "baseName": "patientId",
            "type":     "string"
        },
        {
            "name":     "phone",
            "baseName": "phone",
            "type":     "string"
        },
        {
            "name":     "contactName",
            "baseName": "contactName",
            "type":     "string"
        },
        {
            "name":     "contactNumber",
            "baseName": "contactNumber",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return MedicalV1PriorAuthorizationInterfacesPriorAuthorizationPatient.attributeTypeMap;
    }
}
